import { normalize } from "normalizr";
import { Groups, Preguntas, Respuestas, Users, Viajes } from "./schema";

const firebaseReducer = (
  state = {
    groups: { byId: {}, allIds: [] },
    users: { byId: {}, allIds: [] },
    viajes: { byId: {}, allIds: [] },
    preguntas: { byId: {}, allIds: [] },
    respuestas: { byId: {}, allIds: [] }
  },
  action
) => {
  switch (action.type) {
    case "FETCHED_FIREBASE_ENTITIES": {
      const { users, groups, viajes, preguntas, respuestas } = action.payload;
      const normalizedUsers = normalize(users || {}, [Users]);
      const normalizedGroups = normalize(groups || {}, [Groups]);
      const normalizedViajes = normalize(viajes || {}, [Viajes]);
      const normalizedRespuestas = normalize(respuestas || {}, [Respuestas]);
      const normalizedPreguntas = normalize(preguntas || {}, [Preguntas]);

      return {
        ...state,
        users: {
          allIds: normalizedUsers.result,
          byId: normalizedUsers.entities.users
        },
        groups: {
          allIds: normalizedGroups.result,
          byId: normalizedGroups.entities.groups
        },
        viajes: {
          allIds: normalizedViajes.result,
          byId: normalizedViajes.entities.viajes
        },
        respuestas: {
          allIds: normalizedRespuestas.result,
          byId: normalizedRespuestas.entities.respuestas
        },
        preguntas: {
          allIds: normalizedPreguntas.result,
          byId: normalizedPreguntas.entities.preguntas
        }
      };
    }

    default:
      return state;
  }
};

export default firebaseReducer;
